import React from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';

import dr_hakaru from '../../img/dr-hakaru.webp'

import ja_Trans from '../../locales/ja/404.json'
import en_Trans from '../../locales/en/404.json'
import cn_Trans from '../../locales/cn/404.json'
import { isMobile } from 'react-device-detect';

const NotFoundApp: React.FC = () => {
    const { t } = useTranslation('404');
    i18next.addResources('ja', '404', ja_Trans);
    i18next.addResources('en', '404', en_Trans);
    i18next.addResources('cn', '404', cn_Trans);
    return (
        <React.StrictMode>
            <Typography variant="h1" hidden>Page Not Found</Typography>
            <Stack
                justifyContent="center"
                alignItems="center"
            >

                <Box
                    component="img"
                    src={dr_hakaru}
                    style={
                        isMobile
                            ? { height: "200px", maxWidth: "80%" }
                            : { width: "200px", maxHeight: "80%" }
                    }
                />
                <Typography>{t('Page Not Found')}</Typography>
            </Stack>
        </React.StrictMode >
    );

}

export default NotFoundApp;